import { useSyncExternalStore } from "react";
import { applyThemeMode, loadThemeMode, type ThemeMode } from "@jkast90/kast-common/theme";
import { onPreferencesApplied, setPref } from "./preferences";

// CloudBoy's wiring around @jkast90/kast-common/theme. The choice is a setting
// like the others (preferences.ts KEYS), so it follows the account; the key
// is the one index.html's no-flash script reads.
export const THEME_KEY = "pocket-play.theme";

const listeners = new Set<() => void>();
let current: ThemeMode = "system";

function apply(mode: ThemeMode) {
  current = mode;
  applyThemeMode(mode);
  listeners.forEach((listener) => listener());
}

/** Applies the saved choice and, when the account's settings arrive, theirs. Call once at load. */
export function startTheme(): () => void {
  apply(loadThemeMode(THEME_KEY));
  return onPreferencesApplied(() => apply(loadThemeMode(THEME_KEY)));
}

/** Saves a choice, sends it to the account, and applies it. */
export function setThemeMode(mode: ThemeMode) {
  setPref(THEME_KEY, mode);
  apply(mode);
}

function subscribe(listener: () => void) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

/** The chosen mode (not the resolved theme), kept current across controls. */
export function useThemeMode(): ThemeMode {
  return useSyncExternalStore(subscribe, () => current);
}
